import React, { useState, useCallback } from 'react';

import { useClickOutSide } from '../../../utils';
import { ButtonMenuSelectIcon } from '../button-menu-select-icon';
import { MenuIcons } from '../menu-icons';
import { Styled } from './styled';

const useClose = (isOpen, setIsOpen) => {
  const closeMenu = useCallback(() => {
    setIsOpen(false);
  }, []);
  const [innerSideRef] = useClickOutSide(closeMenu, isOpen);
  return [innerSideRef, closeMenu];
};

export const MenuSelectIcons = React.memo(
  ({ disabled, position, onIconClick, selectedId, iconListMap }) => {
    const [isOpen, setIsOpen] = useState(false);
    const toggleIsOpen = useCallback(() => setIsOpen(!isOpen), [isOpen]);
    const [innerSideRef] = useClose(isOpen, setIsOpen);

    return (
      <Styled.Container
        position={position === 'right'}
        ref={innerSideRef}
      >
        {isOpen && (
          <MenuIcons
            iconId={selectedId}
            iconListMap={iconListMap}
            position={position === 'right'}
            onIconClick={onIconClick}
          />
        )}
        <ButtonMenuSelectIcon
          Icon={iconListMap[selectedId]}
          onClick={toggleIsOpen}
          disabled={disabled}
        />
      </Styled.Container>
    );
  }
);
